// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import md5 from 'js-md5';

// 解决：vue Promise”未定义
import promise from 'es6-promise'
promise.polyfill();

// 引入element-ui
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import { getCookie } from './utils/auth'
Vue.use(ElementUI)

// 引入图片缩放插件
import preview from 'vue-photo-preview'
import 'vue-photo-preview/dist/skin.css'
Vue.use(preview)

// 增加API接口
import api from "@/api";
Vue.use(api);

Vue.prototype.$md5 = md5;
Vue.config.productionTip = false

router.beforeEach(async (to, from, next) => {
  if (getCookie('token')) {
    if (to.path === '/login') {
      next({ path: '/admin' })
    } else {
      next()
    }
  } else if (to.path === '/admin/admin-home' || to.path === '/admin/admin-img') {
    next({ path: '/login' })
  } else {
    next()
  }
}),
  /* eslint-disable no-new */
  new Vue({
    el: '#app',
    router,
    components: { App },
    template: '<App/>'
  })



// WEBPACK FOOTER //
// ./src/main.js